<template>
  <div>
    <dv-full-screen-container class="home">
      <Header WeatherCode="330000" :title="(city?city=='温州市'?'乐清市':city:province)+'资源循环利用数据驾驶舱'" ></Header>
      <div class="center">
        <!-- 左侧 -->
        <div class="center-left" v-if="areaType!='province'">
          <div class="box">
            <Nav navtitle="回收分布图" ></Nav>
            <Pie chartId="chart1" :seriesData="seriesDataPie" :area="nowArea"></Pie>
          </div>
          

          <div class="box">
            <Nav navtitle="回收量统计"></Nav>
            <Bar :province="province" :city="city" url="/screen/screen/city/trend" chartId="chart2"></Bar>
          </div>

          <div class="box">
            <Nav navtitle="回收走势"></Nav>
            <Lines :province="province" :city="city" url="/screen/screen/city/trend" chartId="chart3"></Lines>
          </div>
        </div>

        <div class="center-left province" v-else>
          <div class="box">
            <Nav navtitle="废纸回收价格趋势图"></Nav>
            <provinceLine chartId="chart10"></provinceLine>
          </div>

          <div class="box">
            <Nav navtitle="废钢材回收价格趋势图"></Nav>
            <provinceLine chartId="chart20"></provinceLine>
          </div>

          <div class="box">
            <Nav navtitle="可回收垃圾统计"></Nav>
            <provinceBar chartId="chart30"></provinceBar>
          </div>
        </div>

        <!-- 中间 -->
        <div class="main">
          <CenterInfo @change="changeTab" :nowArea="nowArea" ></CenterInfo>
          <div class="mapinfo" style="position: relative;">
            <!-- <Maps :maptabval="maptabval">
              <template v-slot:tab>
                <Tab
                  :tabval="maptabval"
                  :data="maptabdata"
                  @change="maptabchange"
                ></Tab>
              </template>
            </Maps> -->
            <div class="typelist" v-show="areaType=='city'">
              <div @click="filterMap(1)" style="display:flex">
                <img src="https://hlgzhhj.oss-cn-hangzhou.aliyuncs.com/2022/10/14/14/1665728259145j4BJaTAV.png" alt="">
                <div class="name cursorpointer">园区</div>
              </div>
              <div @click="filterMap(2)" style="display:flex">
                <img src="https://hlgzhhj.oss-cn-hangzhou.aliyuncs.com/2022/10/14/14/1665728259145I7JNEezT.png" alt="">
                <div class="name cursorpointer">处置企业</div>
              </div>
              <div @click="filterMap(3)" style="display:flex">
                <img src="https://hlgzhhj.oss-cn-hangzhou.aliyuncs.com/2022/10/14/14/1665728259145zvdV3F6I.png" alt="">
                <div class="name cursorpointer">回收点</div>
              </div>
              
            </div>
            <map1 :province="province" :city="city" @mapChange="map_change" :filterType="filterType"></map1>
          </div>
          <div class="bt" v-if="areaType!='province'">
            <div class="box">
              <Nav navtitle="二手废品交易统计"></Nav>
              <Bar chartId="chart7"></Bar>
              <!-- <dv-scroll-board :config="config" /> -->
            </div>

            <div class="box">
              <Nav navtitle="半成品销售统计"></Nav>
              <Bar chartId="chart8"></Bar>
              <!-- <dv-scroll-board :config="config" /> -->
            </div>

            <div class="box">
              <Nav navtitle="成品销售统计"></Nav>
              <Bar chartId="chart9"></Bar>
            </div>
          </div>
          
          <div class="bt province" v-else>
            <div class="box">
              <Nav navtitle="装修垃圾统计"></Nav>
              <provinceBar chartId="chart70"></provinceBar>
              <!-- <dv-scroll-board :config="config" /> -->
            </div>

            <div class="box">
              <Nav navtitle="建筑垃圾统计"></Nav>
              <provinceBar chartId="chart80"></provinceBar>
              <!-- <dv-scroll-board :config="config" /> -->
            </div>

            <div class="box">
              <Nav navtitle="大件垃圾统计"></Nav>
              <provinceBar chartId="chart90"></provinceBar>
            </div>
          </div>
        </div>

        <!-- 右侧 -->
        <div class="center-right" v-if="areaType!='province'">
          <div class="box">
            <Nav navtitle="废品库存统计"></Nav>
            <Bar chartId="chart4"></Bar>
          </div>

          <div :reverse="true" class="box">
            <Nav navtitle="废品加工统计"></Nav>
            <Bar chartId="chart5"></Bar>
          </div>

          <div class="box">
            <Nav navtitle="废品利用率走势图"></Nav>
            <Lines chartId="chart6"></Lines>
          </div>
        </div>
        
        <div class="center-right province" v-else>
          <div class="box">
            <Nav navtitle="废铝回收价格趋势图"></Nav>
            <provinceLine chartId="chart40"></provinceLine>
          </div>

          <div class="box">
            <Nav navtitle="废铜回收价格趋势图"></Nav>
            <provinceLine chartId="chart50"></provinceLine>
          </div>

          <div class="box">
            <Nav navtitle="一般工业固废统计"></Nav>
            <provinceBar chartId="chart60"></provinceBar>
          </div>
        </div>
      </div>

      <!-- 入住商家弹窗 -->
      <Pop :status="show" @close="show = false">
        <template v-slot:tab>
          <Tab
            :tabval="poptabval"
            :data="poptabdata"
            @change="pop1tabchange"
          ></Tab>
        </template>
        <template v-slot:FY>
          <Pagination
            :total="1000"
            :currentPage="1"
            @currentChange="changePage"
          ></Pagination>
        </template>
      </Pop>

      <!-- 库存量弹窗 -->
      <Pop :status="show1" @close="show1 = false">
        <template v-slot:tab>
          <Tab
            :tabval="poptabval2"
            :data="poptabdata2"
            @change="pop2tabchange"
          ></Tab>
        </template>
      </Pop>
    </dv-full-screen-container>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Nav from "@/components/Nav.vue";
import map1 from '@/components/Map.vue'
import CenterInfo from "@/components/CenterInfo.vue";
import Bar from "@/components/Chart/Bar.vue";
import Pie from "@/components/Chart/Pie.vue";
import Lines from "@/components/Chart/Line.vue";
import Pagination from "@/components/Pagination.vue";
import Pop from "@/components/Pop.vue";
import Tab from "@/components/Tab.vue";
import provinceLine from '@/components/Chart/provinceLine.vue'
import provinceBar from '@/components/Chart/provinceBar.vue'
import axios from '@/js/axios'
export default {
  name: "HomeView",
  components: {
    Header,
    Nav,
    //Maps,
    map1,
    CenterInfo,
    Bar,
    Pie,
    Lines,
    Pagination,
    Pop,
    Tab,
    provinceLine,
    provinceBar,
},
  data() {
    return {
      province:"",
      city:'',
      areaType:'province',
      seriesDataPie: [
        {
          name: "废玻璃",
          value: 15,
        },
        {
          name: "废塑料",
          value: 10,
        },
        {
          name: "废钢材",
          value: 20,
        },
        {
          name: "废纤维",
          value: 13,
        },
        {
          name: "有色金属",
          value: 20,
        },
        {
          name: "废纸",
          value: 22,
        },
      ],

      maptabval: 1,
      maptabdata: [
        {
          name: "全域",
          num: 1,
        },
        {
          name: "产业园",
          num: 2,
        },
        {
          name: "监控",
        },
      ],
      show: false,
      poptabval: 1,
      poptabdata: [
        {
          name: "废品收购",
          num: 1,
        },
        {
          name: "废金属收购",
          num: 2,
        },
        {
          name: "废塑料加工",
          num: 3,
        },
        {
          name: "废纤维收购",
          num: 4,
        },
      ],
      show1: false,
      poptabval2: 1,
      poptabdata2: [
        {
          name: "非金属",
          num: 1,
        },
        {
          name: "废塑料",
          num: 2,
        },
        {
          name: "废纸",
          num: 3,
        },
        {
          name: "废橡胶",
          num: 4,
        },
        {
          name: "废玻璃",
          num: 5,
        },
        {
          name: "废棉织物",
          num: 6,
        },
        {
          name: "废电器电子产品",
          num: 7,
        },
      ],
      nowArea:[''],
      filterType:0,
    };
  },

  created() {
    
    console.log('query',this.$route.query.province,this.city)
    this.province=this.$route.query.province
    this.nowArea=[this.$route.query.province,this.city]
    window.addEventListener('popstate',()=>{
      this.$destroy()
      // this.city=''
      // this.nowArea[1]=''
      // this.areaType='province'
      console.log('监听返回')
    } , false);
  },
  mounted() {
    if(sessionStorage.getItem('city')){
      //this.nowArea.push(sessionStorage.getItem('city'))
      console.log('this.nowArea',this.nowArea)
      this.city=sessionStorage.getItem('city')
      console.log('mounted',[this.province,this.city])
      this.map_change([this.province,this.city])
    }
    window.addEventListener('beforeunload', (event) => {
      
        sessionStorage.setItem('city',this.city)
      
    });
  },
  
  activated(){
    console.log('keeplive进入',this.$route.query.province)
    if(this.$route.query.province){
      this.province=this.$route.query.province
      this.nowArea=[this.$route.query.province,this.city]
    }
  },
  methods: {
    filterMap(type){
      console.log(this.filterType)
      this.filterType=type==this.filterType?0:type
      
    },
    map_change(e){
      console.log('map_change',e)
      this.areaType=e
      if(e.length==2){
        this.areaType='city'
        this.city=e[1]
      }else{
        this.areaType='province'
        this.city=''
      }
      this.nowArea=e
    },
    changeTab(item, index) {
      console.log(item, index, "选择的标签");
      switch (index) {
        case 0:
          this.show = true;
          break;
        case 1:
          this.$router.push("car");
          break;
        case 2:
          this.show1 = true;
          break;
        case 3:
          this.$router.push("recovery");
          break;
        case 4:
          this.$router.push("cumulative");
          break;
        case 7:
          this.show1 = true;
          break;
        case 8:
          this.show1 = true;
          break;

        default:
          break;
      }
    },

    // 弹窗分页器
    changePage(e) {
      console.log(e, "分页器");
    },

    // 地图切换
    maptabchange(val) {
      console.log(val, "地图tab切换数据");
      this.maptabval = val.num ? val.num : this.maptabval;
      if (!val.num) {
        this.$router.push("watch");
      }
    },

    // 入驻商家弹窗Tab
    pop1tabchange(val) {
      this.poptabval = val.num;
    },

    // 库存量弹窗
    pop2tabchange(val) {
      this.poptabval2 = val.num;
    },
  },
};
</script>
<style scoped lang="scss">
.home {
  background: #000;
  //background: url(../assets/bgimg.png) no-repeat;
  background-size: 100% 100%;
  overflow: auto !important;

  .center {
    width: 100%;
    height: calc(100% - 80px);
    display: flex;
    justify-content: space-between;
    padding: 0 10px 10px 10px;

    .main {
      width: 50%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .mapinfo {
        width: 100%;
        height: 30%;
        flex: 1;
      }

      .bt {
        display: flex;
        justify-content: space-around;

        .box {
          width: 49%;
          height: 274px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .dv-scroll-board {
            width: calc(90% + 10px);
            height: calc(100% - 50px);
            margin-left: 15px;
            .rows {
              .row-item {
                border-bottom: 1px solid #129bff !important;
              }
            }
          }
        }
      }
    }

    .center-left,
    .center-right {
      width: 25%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .box {
        width: 100%;
        flex: 1;
        //height: 300px;
      }

      .box:nth-child(2) {
        margin: 20px 0;
      }
    }
  }
}
.typelist{
  position: absolute;
  right: 30px;
  top: 10px;
  display: flex;
  align-items: center;
  font-size: 15px;
  color: #fff;
  z-index: 100;
  img{
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
  .name{
    margin-right: 30px;
  }
}
</style>
